import type { ChipKind } from '../types';

const CHIP_KINDS: readonly string[] = ['tag', 'generic', 'brand', 'manufacturer', 'application'];

/** Legacy ``?kwInput=`` → scope, for the one-shot link migration in
 *  SearchPage. Absent/unknown = All; legacy ``instant`` = Generic. */
export function parseKwInput(value: string | null): 'all' | 'label' | ChipKind {
  if (value === 'instant') return 'generic';
  if (value === 'label') return 'label';
  return value !== null && CHIP_KINDS.includes(value) ? (value as ChipKind) : 'all';
}
